import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawCollapseDirectiveSharedModule } from '@shared/core/directives/drawCollapse/draw-collapse.directive.shared.module';

import { FiltersDrawModule } from '@shared/core/components/filtersDraw';
import { LoyaltyMessagesModule } from '@shared/core/components/loyaltyMessages';

import { MainDrawComponent } from './main-draw.shared.component';

@NgModule({
    declarations: [
        MainDrawComponent,
    ],
    imports: [
        CommonModule,
        FiltersDrawModule,
        DrawCollapseDirectiveSharedModule,
        LoyaltyMessagesModule,
    ],
    exports: [
        MainDrawComponent,
    ],
})
export class MainDrawModule { }
